function parseJSON(response) {
    var contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        return response.json();
    }

    return null;
}

async function throwIfError(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }

    const error = new Error(response.statusText);
    Object.assign(error, await parseJSON(response));
    throw error;
}

export class Http {
    async fetch(method, url, payload) {
        const options = {
            method: method,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (payload) options.body = JSON.stringify(payload);

        const resp = await fetch(`${process.env.VUE_APP_API_ENDPOINT || ''}${url}`, options);
        return await throwIfError(resp);
    }

    async get(url) {
        const response = await this.fetch('GET', url);
        return parseJSON(response);
    }

    async post(url, payload) {
        const response = await this.fetch('POST', url, payload);
        return parseJSON(response);
    }

    async put(url, payload) {
        const response = await this.fetch('PUT', url, payload);
        return parseJSON(response);
    }
}

export const http = new Http();
